/**
 * Rewards Integration Extension for Update Meals
 *
 * Handles rewards (redeem) application via context menu.
 */
(function() {
  'use strict';

  if (!window.etUpdateMealsExtensions) {
    window.etUpdateMealsExtensions = {};
  }

  const extensions = window.etUpdateMealsExtensions;
  let listenersInstalled = false;

  function handleApplyRewardsClick(event) {
    const state = extensions.getState?.();
    const parseOptionalSubscriptionId = extensions.parseOptionalSubscriptionId;
    const showInlineErrorToast = extensions.showInlineErrorToast;

    if (!state || !parseOptionalSubscriptionId || !showInlineErrorToast) {
      console.warn('[Update Meals Rewards] Extension dependencies not available');
      return;
    }

    const applyRewardsTrigger =
      event?.target instanceof Element
        ? event.target.closest('[data-action="et-apply-rewards"]')
        : null;
    if (!(applyRewardsTrigger instanceof HTMLElement)) {
      return;
    }

    if (
      applyRewardsTrigger.getAttribute('aria-disabled') === 'true' ||
      applyRewardsTrigger.getAttribute('data-et-disabled') === 'true' ||
      applyRewardsTrigger.disabled ||
      applyRewardsTrigger.hasAttribute('disabled')
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const subscriptionId = parseOptionalSubscriptionId(
      applyRewardsTrigger.getAttribute('data-subscription-id') ||
        state.overviewSlotSubscriptionId
    );
    if (!subscriptionId) {
      showInlineErrorToast('Subscription is still loading. Please try again.');
      return;
    }

    if (typeof window.etApplyRewards === 'function') {
      window.etApplyRewards(subscriptionId);
    } else {
      console.warn('[Update Meals] Apply rewards handler not available');
    }
  }

  function installRewardsListeners() {
    if (listenersInstalled) return;
    listenersInstalled = true;
    document.addEventListener('click', handleApplyRewardsClick, true);
  }

  extensions.rewards = {
    installListeners: installRewardsListeners,
    handleApplyRewardsClick,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installRewardsListeners);
  } else {
    installRewardsListeners();
  }

})();
